import {
  Box,
  CircularProgress,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useAppDispatch, useTrading } from "features/store";
import { useListStrategiesQuery } from "features/trading/accounts";
import { setCurrentStrategy } from "features/trading/tradingSlice";
import { getLastStrategyId, getStrategyPickerHighlightColor } from "helpers";
import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const StrategyPicker = () => {
  const { currentStrategyGroupId, currentStrategy } = useTrading();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  // Check if URL params are present - if so, don't auto-select
  const hasUrlParams = useMemo(
    () =>
      !!searchParams.get("strategy_id") &&
      !!searchParams.get("strategy_group_id"),
    [searchParams],
  );

  const { data, isLoading } = useListStrategiesQuery(
    {
      pagination: { page: 0, pageSize: 100 },
      filters: {
        strategy_group: currentStrategyGroupId,
        include_last_call_close: true,
      },
    },
    { skip: !currentStrategyGroupId },
  );

  useEffect(() => {
    // Skip auto-selection if URL params are present (URL strategy hook handles it)
    if (hasUrlParams) return;

    const lastStrategyId = currentStrategy?.id || getLastStrategyId();
    if (data && data.results.length > 0) {
      dispatch(
        setCurrentStrategy(
          data.results.find((strategy) => strategy.id === lastStrategyId) ||
            data.results[0],
        ),
      );
    }
  }, [data, currentStrategy, dispatch, setCurrentStrategy, hasUrlParams]);

  return data &&
    !isLoading &&
    data.results.some((strategy) => strategy.id === currentStrategy?.id) ? (
    <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
      <Select
        labelId="account-label"
        label="Account"
        size="small"
        value={currentStrategy ? currentStrategy.id : ""}
        sx={{ width: 250, borderRadius: 5 }}
        onChange={(event) => {
          const strategy = data.results.find(
            (strategy) => strategy.id === event.target.value,
          );
          dispatch(setCurrentStrategy(strategy));
        }}
      >
        {data.results.map((strategy) => (
          <MenuItem
            key={strategy.id}
            value={strategy.id}
            sx={{ background: getStrategyPickerHighlightColor(strategy) }}
          >
            {strategy.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  ) : (
    <CircularProgress />
  );
};
